import json from './sprite.js';

export default {
    handle: 'en_SPT14-Homework',
    label: 'en_SPT14-Homework',
    json,
};
